<div class="modal-header primaryBgColor grayFontColor">
    <h5 class="modal-title">Kind ausw&auml;hlen</h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <span ngbAutofocus tabindex="-1"></span>
    <ng-container *ngIf="eltern; else noParent">
        <div class="mb-2 small">
            Elternteil: {{ eltern.vorname }} {{ eltern.nachname }}
        </div>

        <app-filter [categories]="categories"
                    [(query)]="query"
                    [useUrlBar]="false"
                    (queryChange)="updateFilter()"></app-filter>

        <div *ngIf="kinder.length === 0" class="text-center py-4">
            Keine Kinder gefunden.
        </div>

        <div class="list-group">
            <button class="list-group-item list-group-item-action d-flex justify-content-between align-items-center primaryBgColor grayFontColor"
                    *ngFor="let kind of kinder"
                    (click)="select(kind)">
                <div>
                    <div class="font-weight-bold">{{ kind.vorname }} {{ kind.nachname }}</div>
                    <div class="small">{{ kind.geburtsdatum | ageFilter }} Jahre alt</div>
                    <div class="small">{{ kind.strasse }} {{ kind.hausnummer }}, {{ kind.plz }} {{ kind.ort }}</div>
                </div>
                <span class="badge badge-secondary badge-pill">{{ kind.id }}</span>
            </button>
        </div>
    </ng-container>
    <ng-template #noParent>
        <div class="text-center py-4">
            Bitte zuerst einen Elternteil auswaehlen.
        </div>
    </ng-template>
</div>

<div class="modal-footer">
    <button class="btn scButton" (click)="activeModal.dismiss()">Abbrechen</button>
</div>
